import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: API_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para logging (desenvolvimento)
api.interceptors.request.use(
  (config) => {
    console.log(`🚀 Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log(`✅ Response: ${response.config.url}`, response.data);
    return response;
  },
  (error) => {
    console.error('❌ Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Serviços de métricas
export const metricsService = {
  getDashboard: (params) => api.get('/api/metrics/dashboard', { params }),
  getServiceLevel: (params) => api.get('/api/metrics/service-level', { params }),
  getTMA: (params) => api.get('/api/metrics/tma', { params }),
  getTME: (params) => api.get('/api/metrics/tme', { params }),
  getCSAT: (params) => api.get('/api/metrics/csat', { params }),
  getChannelDistribution: (params) => api.get('/api/metrics/channel-distribution', { params }),
  getHeatMap: (params) => api.get('/api/metrics/heatmap', { params }),
  getChannelRanking: (params) => api.get('/api/metrics/channel-ranking', { params }),
  getSLAAlerts: (params) => api.get('/api/metrics/sla-alerts', { params }),
  getAgentMetrics: (params) => api.get('/api/metrics/agent-metrics', { params }),

  // ==========================================
  // DASHBOARD DO SUPERVISOR
  // ==========================================
  getSupervisorDashboard: (params) => api.get('/api/metrics/supervisor/dashboard', { params }),
  getOnlineAgents: (params) => api.get('/api/metrics/supervisor/online-agents', { params }),
  getQueueByAgent: (params) => api.get('/api/metrics/supervisor/queue-by-agent', { params }),
  getSLAByAgent: (params) => api.get('/api/metrics/supervisor/sla-by-agent', { params }),
  getDailyPerformance: (params) => api.get('/api/metrics/supervisor/daily-performance', { params }),
  getActionAlerts: (params) => api.get('/api/metrics/supervisor/action-alerts', { params }),

  // ==========================================
  // KPIs EM TEMPO REAL
  // ==========================================
  getRealTimeKPIs: (params) => api.get('/api/metrics/realtime/kpis', { params }),

  // ==========================================
  // KPIs DE COBRANÇA
  // ==========================================
  getVolumeKPIs: (params) => api.get('/api/metrics/volume/kpis', { params }),
  getVolumeByAgent: (params) => api.get('/api/metrics/volume/by-agent', { params }),
  getVolumeByPortfolio: (params) => api.get('/api/metrics/volume/by-portfolio', { params }),
  getDetailedSLA: (params) => api.get('/api/metrics/sla/detailed', { params }),
  getQueueTime: (params) => api.get('/api/metrics/sla/queue-time', { params }),

  // ==========================================
  // CONVERSAS PENDENTES DE RETORNO
  // ==========================================
  getPendingConversations: (params) => api.get('/api/metrics/pending-conversations', { params }),
  getAgentProductivity: (params) => api.get('/api/metrics/agent-productivity', { params }),
};

// Serviços de agentes
export const agentsService = {
  getAll: () => api.get('/api/agents'),
  getById: (id) => api.get(`/api/agents/${id}`),
};

// Serviços de canais
export const channelsService = {
  getAll: () => api.get('/api/channels'),
  getById: (id) => api.get(`/api/channels/${id}`),
  getTypes: () => api.get('/api/channels/types/list'),
};

// Serviços de times
export const teamsService = {
  getAll: () => api.get('/api/teams'),
  getById: (id) => api.get(`/api/teams/${id}`),
  getMembers: (id) => api.get(`/api/teams/${id}/members`),
};

// Serviços de etiquetas
export const labelsService = {
  getAll: () => api.get('/api/labels'),
  getById: (id) => api.get(`/api/labels/${id}`),
};

export default api;
